export default __webpack_public_path__ + "static/media/36I-120773_-43973_0.7f9ffc30.jpg";